const xyglGetter = {
    getMyStudys(state) {
        _.forEach(state.studys.Items, obj => {
            obj.percentage = 0;
            if (obj.CompleteLessonCount && obj.CompleteLessonCount) {
                obj.percentage = obj.CompleteLessonCount / obj.LessonCount * 100;
            }
        })
        return state.studys;
    },
    getMyStudysDetails(state) {
        let percentage = 0;
        if (state.studyDetails.CompleteLessonCount && state.studyDetails.CompleteLessonCount) {
            percentage = state.studyDetails.CompleteLessonCount / state.studyDetails.LessonCount * 100;
        }
        state.studyDetails.percentage = percentage;
        return state.studyDetails;
    },
    getMyStudyLessonDetails(state) {
        return state.studyLessonDetails;
    },
    getPosttestQuestions(state) {
        return state.posttestQuestions;
    },
    getCourseExamQuestions(state) {
        return state.courseExamQuestions;
    },
    getCertLearncert(state) {
        return state.certLearncert;
    },
    getEmployeePersonaLprofile(state) {
        return state.personaLprofile;
    }
}

export default xyglGetter;



// WEBPACK FOOTER //
// ./src/store/jzjy/getters/xyglGetter.js